var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { NavButton } from 'hx-navigator';
import { cn } from 'hx-util';
import { useFormContext } from 'react-hook-form';
export function NavigationButtonsContainer(_a) {
    var children = _a.children, className = _a.className;
    return (_jsx("div", __assign({ className: cn('flex gap-4 sm:gap-10 mx-auto w-[85%] sm:w-fit py-4', className) }, { children: children })));
}
export function NavigationButton(props) {
    return (_jsx(NavButton, __assign({}, props, { className: cn('sm:w-60 sm:max-w-60 py-3 w-full disabled:bg-primary/40', props.className) })));
}
export function FormNavigationButton(props) {
    var formState = useFormContext().formState;
    var errors = formState.errors;
    return (_jsx(NavButton, __assign({}, props, { className: cn('sm:w-60 sm:max-w-60 py-3 w-36 max-w-36 disabled:bg-primary/40', props.className), disabled: props.type === 'submit' && Boolean(Object.keys(errors).length) })));
}
